import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import TillClosingForm from './forms/TillClosingForm';
import TillClosingList from './lists/TillClosingList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import connect from "react-redux/es/connect/connect";
import {calcClassName, isEmpty} from "../../utils/other";
import is_numeric from "locutus/php/var/is_numeric";

class TillClosingEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    getFieldProps = (field) => {
        const props = this.props.getFieldProps(field);
        if (this.props.values[this.props.componentConfig.idfield]) {
            props.disabled = props.disabled || true;
        }
        return props;
    }

    render() {

        if (!(this.props.till || {}).id) {
            return <Box header="Hiba" theme="danger">
                Kérlek jelentkezz be egy Kasszába!
            </Box>;
        }

        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;

        let filter = [];
        if (this.props.till && this.props.till.pos && this.props.till.pos.id) {
            filter = [{field: "till", value: this.props.till.id}];
        }

        const closings = (this.props.values.closings || []);
        const sums = closings.map((closing) => {
            const values = {current: closing.current, amount: closing.amount, total: closing.total};
            values.total = parseFloat(values.total);
            if (closing.moneyrepository.component_type === "CreditCardTerminal") {
                values.total = parseFloat(values.total) + parseFloat(closing.invoice_total || 0);
            }
            values.total += parseFloat(closing.storno);
            values.total = Math.round(values.total);
            return values;
        });
        const disabled = sums.filter((closing) => {
            const classes = calcClassName(closing);
                return !(classes.current === 3 && classes.current === classes.total && classes.total === classes.amount) && (
                    !(classes.current > 1 && closing.current !== undefined && closing.current !== null && closing.current !== "")
                    ||
                    !(classes.amount > 1 && closing.amount !== undefined && closing.amount !== null && closing.amount !== "")
                    ||
                    !(classes.total > 1 && closing.total !== undefined && closing.total !== null && closing.total !== "")
                );
            }).length > 0
            ||
            !is_numeric(this.props.values.transaction_count)
            ||
            isEmpty(this.props.values.closing_number)
            ||
            closings.map((closing) => {
                if (closing.moneyrepository.component_type === "CreditCardTerminal") {
                    return closing.invoice_total === undefined;
                }
            }).find((f) => f)
            ||
                this.props.values.total + ""
                    !==
                "" + (!(this.props.values.vatrate_closings || []).length ? undefined : (this.props.values.vatrate_closings || []).map((vatrate_closing) => vatrate_closing.amount).reduce((sum, amount) => parseFloat(sum || "0") + parseFloat(amount || "0")))
            ||
                (isNaN(this.props.values.total + "") && isEmpty(this.props.values.total)) || (this.props.values.vatrate_closings || []).find((closing) => closing.amount === undefined || closing.amount === null || closing.amount === "");

        return (
            <Fragment>
                <List
                    {...this.props}
                    theme="default"
                    header={"Zárások"}
                    footer={[
                        <Button
                            key="0"
                            color="default"
                            disabled={this.props.isLoading}
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <TillClosingList ref={(el) => this.list = el} {...this.props} filter={filter} loadForm={this.loadForm} getFieldProps={this.getFieldProps} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Zárás"}
                    footer={[
                        <Button
                            key="0"
                            disabled={disabled || !this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>
                    ]}
                >
                    <TillClosingForm {...this.props} getFieldProps={this.getFieldProps} sums={sums} />
                </Editor>
            </Fragment>
        );
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(createEditor({componentName: "TillClosing", WrappedComponent: TillClosingEditor}));
